class AblyWebSocketPushMessageProvider {
    constructor() {}

    async initialize({ channel, event }) {


        console.log("AblyWebSocketPushMessageProvider initialized")
        return new Promise((resolve, reject) => {
            touchKit.WebSocketManager.getConnection().then((con) => {
               
                const messages = con.channels.get(channel);
                messages.subscribe(event, (message) => {


                    message.data.type = message.data.template
                    console.log("AblyWebSocketPushMessageProvider.subscription ", event, message)
                    app.radio.$emit(event, message);
                });

                resolve();
            });
        });
    }
}
touchKit.PushMessageManager.registerStrategy( "AblyWebSocketPushMessageProvider", () => {
    return new AblyWebSocketPushMessageProvider();
});
